import { render, staticRenderFns } from "./BuyOrderSendLinks.vue?vue&type=template&id=2cfd1cde&"
import script from "./BuyOrderSendLinks.vue?vue&type=script&lang=js&"
export * from "./BuyOrderSendLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports